export const completeRcdPreload = () => {
    const preloader = document.querySelector("[data-rcd-preloader]");
    if (!preloader) {
        document.body.classList.remove("rcd-preloading");
        return;
    }

    window.requestAnimationFrame(() => {
        preloader.classList.add("is-hidden");
        document.body.classList.remove("rcd-preloading");
        preloader.addEventListener("transitionend", () => preloader.remove(), { once: true });
    });
};

export const hideRcdPreloaderWhenReady = () => {
    if (document.readyState === "complete") {
        completeRcdPreload();
        return;
    }

    window.addEventListener("load", completeRcdPreload, { once: true });
};
